import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage = 'Hola, me interesa activar la propuesta Danimar x TNO Network en Expedientes del Delito con Angélica Lugo y Santiago Gutiérrez.';

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom={2}
      >
        ¿Listo para activar Operativo Danimar?
      </Box>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 2, maxWidth: 720, mx: 'auto' }}
      >
        Olviden los comerciales tradicionales. Queremos que Danimar sea parte del rigor de{' '}
        <strong>Expedientes del Delito</strong>, con <strong>Angélica Lugo y Santiago Gutiérrez</strong> en estudio,
        bajo el concepto de <strong>justicia para tu hogar</strong>.
      </Typography>
      <Typography
        variant="body1"
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 720, mx: 'auto' }}
      >
        Por <strong>$300/mes</strong>, campaña de alta factura con frases potentes, presencia en el formato híbrido
        televisión y podcast de TNO Network (streaming 24/7) y posicionamiento en Google que trata el producto como la
        solución técnica definitiva. Es hora de que Danimar
        resuelva el caso de su posicionamiento en el mercado.
      </Typography>

      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          component="img"
          src="/images/AngelicaySantiago.png"
          alt="Angélica Lugo y Santiago Gutiérrez - Expedientes del Delito"
          sx={{
            width: '100%',
            maxWidth: 420,
            borderRadius: 2,
            boxShadow: 3,
            objectFit: 'cover',
            mb: 1,
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <Typography variant="subtitle1" fontWeight={600} align="center" sx={{ mb: 0.5 }}>
          Angélica Lugo y Santiago Gutiérrez
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center" sx={{ mb: 4, maxWidth: 420 }}>
          Dúo de autoridad editorial · Investigación, contexto y veredicto para marcas que necesitan confianza.
        </Typography>

        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          gap={2}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              const url = `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`;
              window.open(url, '_blank');
            }}
          >
            Contactar para propuesta Danimar
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>

      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Danimar & TNO Network & Expedientes del Delito | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;

